'use client';

import {useQuery} from '@/sanity/loader/useQuery';

import type {ArticleBySlugQueryResult} from './query';
import {ARTICLE_BY_SLUG_QUERY} from './query';
import {ArticlePageContainer} from '.';

type Props = {
	params: {slug: string};
	initial: ArticleBySlugQueryResult;
};

export default function ArticlePageContainerDraft({params, initial}: Props) {
	const {data: article} = useQuery<ArticleBySlugQueryResult>(
		initial,
		ARTICLE_BY_SLUG_QUERY,
		params,
	);

	return <ArticlePageContainer article={article} />;
}
